import { render, staticRenderFns } from "./ConfirmStart.vue?vue&type=template&id=3173e4b0&scoped=true&"
import script from "./ConfirmStart.vue?vue&type=script&lang=js&"
export * from "./ConfirmStart.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmStart.vue?vue&type=style&index=0&id=3173e4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3173e4b0",
  null
  
)

export default component.exports